import React from "react";

const Hosting = () => {
  return <div>Hosting Component</div>;
};
export default Hosting;